import "@arco-design/web-react/es/Breadcrumb/style";
import _Breadcrumb from "@arco-design/web-react/es/Breadcrumb";
import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import _IconExclamationCircle from "@arco-design/web-react/icon/react-icon/IconExclamationCircle";
import _IconIdcard from "@arco-design/web-react/icon/react-icon/IconIdcard";
import _IconEdit from "@arco-design/web-react/icon/react-icon/IconEdit";
import _IconBook from "@arco-design/web-react/icon/react-icon/IconBook";
import _IconCloud from "@arco-design/web-react/icon/react-icon/IconCloud";
import _IconGithub from "@arco-design/web-react/icon/react-icon/IconGithub";
import _IconMobile from "@arco-design/web-react/icon/react-icon/IconMobile";
import _IconRecord from "@arco-design/web-react/icon/react-icon/IconRecord";
import _IconHistory from "@arco-design/web-react/icon/react-icon/IconHistory";
import _IconUserGroup from "@arco-design/web-react/icon/react-icon/IconUserGroup";
import _IconApps from "@arco-design/web-react/icon/react-icon/IconApps";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import _IconDesktop from "@arco-design/web-react/icon/react-icon/IconDesktop";
import _IconDriveFile from "@arco-design/web-react/icon/react-icon/IconDriveFile";
import _IconTool from "@arco-design/web-react/icon/react-icon/IconTool";
import _IconStorage from "@arco-design/web-react/icon/react-icon/IconStorage";
import _IconCalendar from "@arco-design/web-react/icon/react-icon/IconCalendar";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import cs from "classnames";
import { useSelector } from "react-redux";
import NProgress from "nprogress";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import useLocale from "./utils/useLocale";
import getUrlParams from "./utils/getUrlParams";
import lazyload from "./utils/lazyload";
import styles from "./style/layout.module.less";
import { normalizeMenuData, flattenMenus, buildParentMap, getFirstMenuPath } from "@/utils/menu";
const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;
const Sider = _Layout.Sider;
const Content = _Layout.Content;
const iconMap = {
  dashboard: _IconDashboard,
  "dashboard/workplace": _IconCalendar,
  cdk: _IconStorage,
  "cdk/index": _IconTool,
  "box/index": _IconTool,
  game: _IconDriveFile,
  "game/index": _IconDesktop,
  system: _IconSettings,
  "system/setting": _IconSettings,
  "system/settings": _IconSettings,
  "system/user-management": _IconUser,
  "system/menu-management": _IconApps,
  "system/role": _IconUserGroup,
  "system/loginlog": _IconHistory,
  "system/operlog": _IconRecord,
  operate: _IconTool,
  "operate/appversion": _IconMobile,
  "operate/app-version": _IconMobile,
  manifest: _IconApps,
  "manifest/github": _IconGithub,
  "manifest/minio": _IconCloud,
  config: _IconBook,
  "config/website": _IconEdit,
  user: _IconUser,
  "user/profile": _IconIdcard
};
const elIconAliasMap = {
  "el-icon-setting": _IconSettings,
  "el-icon-s-tools": _IconSettings,
  "el-icon-user": _IconUser,
  "el-icon-user-solid": _IconUser,
  "el-icon-menu": _IconApps,
  "el-icon-s-grid": _IconApps,
  "el-icon-s-custom": _IconUserGroup,
  "el-icon-time": _IconHistory,
  "el-icon-document": _IconRecord,
  "el-icon-mobile-phone": _IconMobile
};
const titleIconMap = {
  系统设置: _IconSettings,
  APP版本管理: _IconMobile
};
const autoTitleIconPool = [_IconDashboard, _IconSettings, _IconExclamationCircle, _IconUser, _IconStorage, _IconDriveFile, _IconUserGroup, _IconBook, _IconApps, _IconCalendar, _IconTool, _IconDesktop, _IconIdcard, _IconHistory, _IconRecord, _IconEdit, _IconMobile];
const titleIconCache = new Map();
const usedTitleIcons = new Set();

const normalizeTitle = title => title?.trim() || "";

const assignIconForTitle = title => {
  const normalized = normalizeTitle(title);

  if (!normalized || titleIconCache.has(normalized)) {
    return;
  }

  if (titleIconMap[normalized]) {
    const preset = titleIconMap[normalized];
    titleIconCache.set(normalized, preset);
    usedTitleIcons.add(preset);
    return;
  }

  const nextIcon = autoTitleIconPool.find(IconComp => !usedTitleIcons.has(IconComp));

  if (!nextIcon) {
    return;
  }

  titleIconCache.set(normalized, nextIcon);
  usedTitleIcons.add(nextIcon);
};

const collectMenuTitles = (menus, acc = new Set()) => {
  menus.forEach(menu => {
    const normalized = normalizeTitle(menu.title || menu.key);

    if (normalized) {
      acc.add(normalized);
    }

    if (menu.children && menu.children.length) {
      collectMenuTitles(menu.children, acc);
    }
  });
  return acc;
};

const primeTitleIcons = menus => {
  titleIconCache.clear();
  usedTitleIcons.clear();
  const titles = Array.from(collectMenuTitles(menus)).sort((a, b) => a.localeCompare(b, undefined, {
    sensitivity: "base"
  }));
  titles.forEach(title => assignIconForTitle(title));
};

const getTitleBasedIcon = title => {
  const normalized = normalizeTitle(title);
  if (!normalized) return null;

  if (!titleIconCache.has(normalized)) {
    assignIconForTitle(normalized);
  }

  return titleIconCache.get(normalized) || null;
};

const ExceptionPage = lazyload(() => import("./pages/exception/403"));

const getMenuIcon = menu => {
  const customIconName = menu.icon?.trim();

  if (customIconName) {
    const aliasKey = customIconName.toLowerCase();
    const AliasIcon = elIconAliasMap[customIconName] || elIconAliasMap[aliasKey];

    if (AliasIcon) {
      return /*#__PURE__*/React.createElement(AliasIcon, {
        className: styles.icon
      });
    }
  }

  const TitleIcon = getTitleBasedIcon(menu.title);

  if (TitleIcon) {
    return /*#__PURE__*/React.createElement(TitleIcon, {
      className: styles.icon
    });
  }

  const iconKey = (customIconName || menu.key).toLowerCase();
  const IconComponent = iconMap[iconKey] || iconMap[menu.key.split("/")[0]] || iconMap[menu.path.replace(/^\//, "")];

  if (IconComponent) {
    return /*#__PURE__*/React.createElement(IconComponent, {
      className: styles.icon
    });
  }

  if (customIconName && /^(el-|iconfont|icon-)/i.test(customIconName)) {
    return /*#__PURE__*/React.createElement("i", {
      className: cs(styles.icon, styles["icon-custom"], customIconName),
      "aria-hidden": true
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles["icon-empty"]
  });
};

const renderMenuNodes = menus => {
  const nodes = [];
  menus.forEach(menu => {
    if (menu.hide) {
      if (menu.children) {
        nodes.push(...renderMenuNodes(menu.children));
      }

      return;
    }

    const titleNode = /*#__PURE__*/React.createElement(React.Fragment, null, getMenuIcon(menu), /*#__PURE__*/React.createElement("span", null, menu.title));

    if (menu.children && menu.children.length) {
      nodes.push( /*#__PURE__*/React.createElement(SubMenu, {
        key: menu.path,
        title: titleNode
      }, renderMenuNodes(menu.children)));
    } else {
      nodes.push( /*#__PURE__*/React.createElement(MenuItem, {
        key: menu.path
      }, titleNode));
    }
  });
  return nodes;
};

function PageLayout() {
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const locale = useLocale();
  const {
    settings,
    userLoading,
    menuLoading,
    menus: rawMenus = []
  } = useSelector(state => state);
  const menuWidth = settings.menuWidth;
  const navbarHeight = 60;
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const menus = useMemo(() => {
    const normalized = normalizeMenuData(rawMenus || []);
    primeTitleIcons(normalized);
    return normalized;
  }, [rawMenus]);
  const flattenedRoutes = useMemo(() => flattenMenus(menus), [menus]);
  const parentMap = useMemo(() => buildParentMap(menus), [menus]);
  const breadcrumbMap = useMemo(() => {
    const map = new Map();
    flattenedRoutes.forEach(route => {
      map.set(route.path, route.breadcrumb);
    });
    return map;
  }, [flattenedRoutes]);
  const routeComponents = useMemo(() => {
    return flattenedRoutes.map(route => {
      if (!route.component) {
        return null;
      }

      const componentPath = route.component.replace(/^\/+/, "");

      try {
        const Component = lazyload(() => import(`./pages/${componentPath}`));
        return {
          path: route.path,
          Component
        };
      } catch (error) {
        console.error(`Failed to load page: ${componentPath}`, error);
        return null;
      }
    }).filter(Boolean);
  }, [flattenedRoutes]);
  const routeComponentMap = useMemo(() => {
    const map = new Map();
    routeComponents.forEach(route => {
      map.set(route.path, route.Component);
    });
    return map;
  }, [routeComponents]);
  const defaultRoute = useMemo(() => getFirstMenuPath(menus), [menus]);
  const [breadcrumb, setBreadCrumb] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const getOpenKeys = useCallback(currentPath => {
    const keys = [];
    let parent = parentMap.get(currentPath);
    const visited = new Set();

    while (parent && !visited.has(parent)) {
      keys.unshift(parent);
      visited.add(parent);
      parent = parentMap.get(parent);
    }

    return keys;
  }, [parentMap]);
  useEffect(() => {
    if (pathname === "/" && defaultRoute) {
      history.replace(defaultRoute);
      return;
    }

    const crumbs = breadcrumbMap.get(pathname) || [];
    setBreadCrumb(crumbs);
    setSelectedKeys(pathname ? [pathname] : []);
    setOpenKeys(pathname ? getOpenKeys(pathname) : []);
  }, [pathname, breadcrumbMap, defaultRoute, history, getOpenKeys]);

  const onClickMenuItem = key => {
    if (key && key !== pathname) {
      const loader = routeComponentMap.get(key);
      const preload = loader?.preload;
      NProgress.start();

      const navigate = () => {
        history.push(key);
        NProgress.done();
      };

      if (typeof preload === "function") {
        preload().then(navigate).catch(navigate);
      } else {
        navigate();
      }
    }
  };

  const toggleCollapse = () => {
    setCollapsed(prev => !prev);
  };

  const paddingLeft = showMenu ? {
    paddingLeft: collapsed ? 48 : menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = { ...paddingLeft,
    ...paddingTop
  };
  const menuNodes = useMemo(() => renderMenuNodes(menus), [menus]);
  const loading = userLoading || menuLoading;
  return /*#__PURE__*/React.createElement(_Layout, {
    className: styles.layout
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles["layout-navbar"], {
      [styles["layout-navbar-hidden"]]: !showNavbar
    })
  }, /*#__PURE__*/React.createElement(Navbar, {
    show: showNavbar
  })), loading ? /*#__PURE__*/React.createElement(_Spin, {
    className: styles["spin"]
  }) : /*#__PURE__*/React.createElement(_Layout, null, showMenu && /*#__PURE__*/React.createElement(Sider, {
    className: styles["layout-sider"],
    width: menuWidth,
    collapsed: collapsed,
    onCollapse: setCollapsed,
    trigger: null,
    collapsible: true,
    breakpoint: "xl",
    style: paddingTop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["menu-wrapper"]
  }, /*#__PURE__*/React.createElement(_Menu, {
    collapse: collapsed,
    onClickMenuItem: onClickMenuItem,
    selectedKeys: selectedKeys,
    openKeys: openKeys,
    onClickSubMenu: (_, keys) => setOpenKeys(keys)
  }, menuNodes)), /*#__PURE__*/React.createElement("div", {
    className: styles["collapse-btn"],
    onClick: toggleCollapse
  }, collapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null))), /*#__PURE__*/React.createElement(_Layout, {
    className: styles["layout-content"],
    style: paddingStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["layout-content-wrapper"]
  }, !!breadcrumb.length && /*#__PURE__*/React.createElement("div", {
    className: styles["layout-breadcrumb"]
  }, /*#__PURE__*/React.createElement(_Breadcrumb, null, breadcrumb.map((node, index) => /*#__PURE__*/React.createElement(_Breadcrumb.Item, {
    key: index
  }, locale[node] || node)))), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Switch, null, routeComponents.map(route => /*#__PURE__*/React.createElement(Route, {
    key: route.path,
    exact: true,
    path: route.path,
    component: route.Component
  })), defaultRoute && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: defaultRoute
  })), /*#__PURE__*/React.createElement(Route, {
    component: ExceptionPage
  })))), showFooter && /*#__PURE__*/React.createElement(Footer, null))));
}

export default PageLayout;